import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconPlayRound = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon className={className} titleAccess={titleAccess} viewBox="0 0 96 96" fill="none">
    <circle
      cx="48"
      cy="48"
      r="45.9429"
      fill="#D9D9D9"
      fillOpacity="0.1"
      stroke="currentColor"
      strokeWidth="4.11429"
    />
    <path
      d="M39.4065 37.4293C39.4065 35.3178 41.6922 33.9982 43.5208 35.0539L62.8634 46.2214C64.692 47.2771 64.692 49.9164 62.8634 50.9721L43.5208 62.1396C41.6922 63.1953 39.4065 61.8757 39.4065 59.7642L39.4065 37.4293Z"
      fill="currentColor"
    />
  </Icon>
);

export default IconPlayRound;
